<template>
    <v-card :loading="loading" tile>
        <div class="px-4 d-flex align-center">
            <div>
                <v-card-title class="px-0">
                    Configuração da Assinatura
                </v-card-title>
                <v-card-subtitle class="px-0">
                    Use as opções abaixo para mudar produtos da assinatura após certa quantidade de ciclos de pagamento.
                    Ex: após 12 ciclos, mudar para o produto com ID Vindi 456.
                </v-card-subtitle>
            </div>
            <div class="ml-auto">
                <v-menu offset-y>
                    <template #activator="{ on, attrs }">
                        <v-btn color="info" v-bind="attrs" v-on="on">
                            Presets
                            <v-icon right>
                                mdi-chevron-down
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-card min-width="320" max-width="500">
                        <v-list dense>
                            <v-list-item :disabled="!items.length" @click="showSavePresetDialog = true">
                                Salvar configuração atual
                            </v-list-item>
                            <v-divider />
                            <v-list-item v-if="!presets.length" class="text-center grey--text">
                                Nenhum preset salvo
                            </v-list-item>
                            <v-list-item v-for="(preset, index) in presets" :key="index" @click="loadPreset(preset)">
                                <v-list-item-content>
                                    <v-list-item-title class="d-flex align-center">
                                        {{ preset.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn small icon text @click="deletePreset(index)">
                                        <v-icon small>
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>
            </div>
        </div>
        <v-card-text>
            <div v-if="!items.length" class="text-center py-10">
                Nenhum item configurado ainda.
            </div>
            
            <v-row v-for="(item, index) in items" :key="index">
                <v-col cols="4" lg="3">
                    <v-text-field v-model.number="item.cycles" :outlined="true" label="Ciclo" type="number" :rules="[$rules.required()]" hide-details />
                </v-col>
                <v-col cols="5" lg="9" class="d-flex">
                    <v-autocomplete v-model="item.vindi_products" :items="products" :outlined="true" :rules="[$rules.required()]" multiple item-text="name" item-value="id" label="Produtos" hide-details class="mr-4" />

                    <v-btn color="error" height="56" @click="removeItem(index)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <div class="mt-4">
                <v-card outlined @click="addItem">
                    <v-card-text class="text-center grey--text">
                        Adicionar Item
                    </v-card-text>
                </v-card>
            </div>

            <div class="mt-6">
                <v-checkbox v-model="forceProcess" label="Não esperar o próximo ciclo" messages="Ativar essa opção fará o sistema mudar o plano sem esperar o próximo ciclo. Todavia, a cobrança só acontecerá no próximo ciclo."></v-checkbox>
            </div>
        </v-card-text>

        <v-card-actions class="">

            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!isFormValid" :loading="saving" @click="save">
                Salvar
            </v-btn>
        </v-card-actions>

        <!-- Save Preset Dialog -->
        <v-dialog v-model="showSavePresetDialog" max-width="500">
            <v-card>
                <v-card-title>
                    <v-icon left>
                        mdi-content-save
                    </v-icon>
                    Salvar como Preset
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="savePresetForm.name" outlined label="Nome do Preset" placeholder="Ex: Configuração Padrão" :rules="[$rules.required()]" autofocus />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="showSavePresetDialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" :disabled="!savePresetForm.name.trim()" @click="savePreset">
                        Salvar Preset
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    props: {
        subscription: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            products: [],
            presets: [],
            loading: false,
            saving: false,
            forceProcess: false,
            items: [],
            showSavePresetDialog: false,
            savePresetForm: {
                name: ''
            }
        }
    },
    computed: {
        isFormValid() {
            if (this.items.length === 0) {
                return true
            }

            return this.items.every(item => {
                return item.cycles && item.vindi_products?.length
            })
        },
    },
    methods: {
        async loadPresets() {
            const response = await this.$api.getSetting('subscription:config-presets')

            if (response.error || !response.message) return

            this.presets = response.message.value || []

            this.presets.sort((a, b) => a.name.localeCompare(b.name))
        },
        async savePresets() {
            return this.$api.setSetting('subscription:config-presets', this.presets)
        },
        async savePreset() {
            if (!this.savePresetForm.name.trim()) {
                this.$toast('error', 'Nome do preset é obrigatório')
                return
            }

            const newPreset = {
                name: this.savePresetForm.name.trim(),
                items: JSON.parse(JSON.stringify(this.items))
            }

            const existingPresets = [...this.presets]

            existingPresets.push(newPreset)

            this.presets = existingPresets
            this.savePresetForm.name = ''
            this.showSavePresetDialog = false

            await this.savePresets()

            this.$toast('success', 'Preset salvo com sucesso!')
        },
        async loadPreset(preset) {
            this.items = JSON.parse(JSON.stringify(preset.items))
        },
        async deletePreset(index) {
            const updatedPresets = [...this.presets]

            updatedPresets.splice(index, 1)

            this.presets = updatedPresets

            await this.savePresets()

            this.$toast('success', 'Preset deletado com sucesso!')
        },
        async loadProducts() {
            const resp = await this.$api.getVindiProducts()

            if (resp.error) return

            this.products = resp.message
        },
        async loadConfig() {
            const response = await this.$api.getSubscriptionConfig({
                user_id: this.user._id,
                subscription_id: this.subscription.id,
            })

            if (response.error) return

            if (!response.message) {
                this.items = []
                return
            }

            this.items = response.message.items || []
        },
        async load() {
            this.loading = true

            await this.loadProducts()
            await this.loadConfig()
            await this.loadPresets()

            setTimeout(() => {
                this.loading = false
            }, 500)
        },
        addItem() {
            this.items.push({
                cycles: null,
                vindi_product_id: ''
            })
        },
        removeItem(index) {
            this.items.splice(index, 1)
        },
        async save() {
            this.saving = true

            const response = await this.$api.updateSubscriptionConfig({
                force_process: this.forceProcess,
                user_id: this.user._id,
                subscription_id: this.subscription.id,
                data: {
                    items: this.items
                }
            })

            if (response.error) {
                this.saving = false
                return
            }

            setTimeout(() => {
                this.saving = false
                this.$toast('success', 'Configuração salva com sucesso!')
            }, 500)

        }
    },
    created() {
        this.load()
    }
}
</script>
